import type { InputHTMLAttributes } from "react";

/** 项目 shadcn 风格基础输入框。 */
export function Input({ className = "", ...props }: InputHTMLAttributes<HTMLInputElement>) {
  return <input data-slot="input" className={`fm-shadcn-input ${className}`.trim()} {...props} />;
}
